import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-registration-header',
  imports: [],
  templateUrl: './registration-header.component.html',
  styleUrl: './registration-header.component.scss',
})
export class RegistrationHeaderComponent {
  @Input() logoSrc: string = 'assets/logos/clepa_logo.png';
  @Input() title: string = '';
}
